import script from "./Create.vue?vue&type=script&setup=true&lang=js"
export * from "./Create.vue?vue&type=script&setup=true&lang=js"

import "./Create.vue?vue&type=style&index=0&id=5884c0b7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5884c0b7"]])

export default __exports__